import React from "react";
import { MenuItem, SelectProps, Select, styled } from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface SelectTextInputInterface extends SelectProps {
  value?: string;
  placeholder?: string;
  roundedCorners?: boolean;
  options: { label: string; value: string }[];
  fontSize?: number;
  dropdownFontSize?: number;
}

const useStyles = makeStyles({
  menuPaper: {
    maxHeight: "250px !important",
  },
});

const StyledSelectInput = styled(Select, {
  shouldForwardProp: (prop) =>
    prop !== "roundCorners" && prop !== "isPlaceholder" && prop !== "fontSize",
  name: "Select",
})<{
  roundCorners?: boolean;
  isPlaceholder?: boolean;
  fontSize?: number;
  theme?: any;
}>(({ roundCorners = true, fontSize, isPlaceholder, theme }) => ({
  border: roundCorners ? `1px solid ${theme.palette.common.borderGrey}` : 0,
  fontSize: fontSize || 10,
  borderRadius: roundCorners ? 15 : 0,
  background: theme.palette.common.white,
  "& .MuiSelect-select": {
    padding: `8px 14px`,
    "&:focus": {
      background: "none",
    },
  },
  "& .MuiInput-input": {
    "-webkit-text-fill-color": isPlaceholder
      ? "rgba(18, 18, 18, 0.5) !important"
      : theme.palette.common.black,
  },
}));
const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== "size",
  name: "MenuItem",
})<{
  size?: number;
}>(({ size }) => ({
  fontSize: size ? size : 18,
}));
const SelectInput = ({
  value = "",
  placeholder,
  roundedCorners = true,
  options,
  fontSize,
  dropdownFontSize,
  ...props
}: SelectTextInputInterface) => {
  const classes = useStyles();
  const DropDownIcon = ({ className }: { className: string }) => {
    return (
      <i
        className={`font-black fas fa-angle-${
          className.indexOf("MuiSelect-iconOpen") >= 0 ? "up" : "down"
        }`}
        style={{
          position: "absolute",
          right: 10,
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "0.75rem",
          fontWeight: 400,
        }}
      />
    );
  };

  return (
    <StyledSelectInput
      {...props}
      value={value}
      variant="standard"
      IconComponent={DropDownIcon}
      displayEmpty
      color="primary"
      roundCorners={roundedCorners}
      isPlaceholder={value === ""}
      fontSize={fontSize}
      inputProps={{
        MenuProps: {
          classes: { paper: classes.menuPaper },
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        },
      }}
    >
      {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
      {options.map((option: { label: string; value: string }) => (
        <StyledMenuItem value={option.value} size={dropdownFontSize}>
          {option.label}{" "}
        </StyledMenuItem>
      ))}
    </StyledSelectInput>
  );
};

export default SelectInput;
